var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.52 2.90997C9.21003 2.90997 6.52003 5.59997 6.52003 8.90997V11.8C6.52003 12.41 6.26003 13.34 5.95003 13.86L4.80003 15.77C4.09003 16.95 4.58003 18.26 5.88003 18.7C10.19 20.14 14.84 20.14 19.15 18.7C20.36 18.3 20.89 16.87 20.23 15.77L19.08 13.86C18.78 13.34 18.52 12.41 18.52 11.8V8.90997C18.52 5.60997 15.82 2.90997 12.52 2.90997Z",
    stroke: "#F2F4F7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.37 3.2C14.06 3.11 13.74 3.04 13.41 3C12.45 2.88 11.53 2.95 10.67 3.2C10.96 2.46 11.68 1.94 12.52 1.94C13.36 1.94 14.08 2.46 14.37 3.2Z",
    stroke: "#F2F4F7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.52 19.06C15.52 20.71 14.17 22.06 12.52 22.06C11.7 22.06 10.94 21.72 10.4 21.18C9.86002 20.64 9.52002 19.88 9.52002 19.06",
    stroke: "#F2F4F7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.a6f601a43f0224443fb1b6e9e18379c1.svg";
export { ForwardRef as ReactComponent };